import React from 'react'

import Accordion from './Accordion/accordion'
import Banner from './Banner/banner'
import Quote from './Quote/quote'
import ContentBlock from './ContentBlock/content-block'
import SkillsList from './SkillsList/skills-list'
import Story from './Story/story'
import ImageCarousel from './ImageCarousel/image-carousel'
import DualBox from './DualBox/dual-box'
import ContentGrid from './ContentGrid/content-grid'
import VerticalGrid from './VerticalGrid/vertical-grid'
import LogoGrid from './LogoGrid/logo-grid'
import Timeline from './Timeline/timeline'
import NewsList from './News/news-list'


export const convertComponents = ({components, lang, news, localization}) => {
  const renderedComponents = components.map((content, index) => {
    const key = `${content.__typename}-${index}`
    
    if (content.__typename == 'ContentfulAccordion') {
      return (
        <Accordion key={key} content={content} lang={lang}></Accordion>
      )
    } else if (content.__typename == 'ContentfulQuote') {
      return (
        <Quote key={key} content={content} lang={lang}></Quote>
      )
    } else if (content.__typename == 'ContentfulContentBlock') {
      return (
        <ContentBlock key={key} content={content} lang={lang}></ContentBlock>
      )
    } else if (content.__typename == 'ContentfulSkillsList') {
      return (
        <SkillsList key={key} content={content} lang={lang}></SkillsList>
      )
    } else if (content.__typename == 'ContentfulBanner') {
      return (
        <Banner key={key} content={content} lang={lang} localization={localization}></Banner>
      )
    } else if (content.__typename == 'ContentfulNewsList')  {
      return (
        <NewsList key={key} content={content} news={news} lang={lang}></NewsList>
      )
    } else if (content.__typename == 'ContentfulStory') {
      return (
        <Story key={key} content={content} lang={lang}></Story>
      )
    } else if (content.__typename == 'ContentfulImageCarousel') {
      return (
        <ImageCarousel key={key} content={content} lang={lang}></ImageCarousel>
      )
    } else if (content.__typename == 'ContentfulDualBox') {
      return (
        <DualBox key={key} content={content} lang={lang}></DualBox>
      )
    } else if (content.__typename == 'ContentfulContentGrid') {
      return (
        <ContentGrid key={key} content={content} lang={lang}></ContentGrid>
      )
    } else if (content.__typename == 'ContentfulVerticalGrid') {
      return (
        <VerticalGrid key={key} content={content} lang={lang}></VerticalGrid>
      )
    } else if (content.__typename == 'ContentfulLogoGrid') {
      return (
        <LogoGrid key={key} content={content} lang={lang}></LogoGrid>
      )
    } else if (content.__typename == 'ContentfulTimeline') {
      return (
        <Timeline key={key} content={content} lang={lang}></Timeline>
      )
    } else {
      return null
    } 
  })

  return renderedComponents
}


// WEBPACK FOOTER //
// ./src/components/factory.js